import { Injectable } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { AppVersion } from 'src/app/interfaces/support';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PatchNotesService {
  private appsCollection: AngularFirestoreCollection<AppVersion>;
  private apps: Observable<AppVersion[]>;

  constructor(private afs: AngularFirestore) {
    this.appsCollection = this.afs.collection<any>('apps');
    this.apps = this.appsCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as AppVersion;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getApps(): Observable<AppVersion[]> {
    return this.apps;
  }

  getPatchNotes(id: string) {
    return this.appsCollection.doc<AppVersion>(id).collection('versions').get();
  }

  updateAppNotes(app: AppVersion): Promise<void> {
    const appRef = this.afs.firestore.collection('apps').doc(app.id);
    return appRef.update(app);
  }
}
